import { FaFlag, FaRegFlag } from "react-icons/fa";
import { UPDATE_EDIT } from "../../services/graphql/queriesMutations";
import { useMutation } from "@apollo/client";
import { useEffect, useState } from "react";
import { useGlobalContext } from "../context/AuthContext";

interface FlagComponentProps {
  flag: boolean;
  editId: number;
}

const FlagComponent = ({ flag, editId }: FlagComponentProps) => {
  const [isFlagged, setIsFlagged] = useState(flag);

  const [updateEdit] = useMutation(UPDATE_EDIT, {
    onCompleted: (data) => {
      setIsFlagged(data.updateEdit.flag);
    },
    onError: (error) => {
      console.error("Error updating flag:", error);
    },
  });

  const { user } = useGlobalContext();

  useEffect(() => {
    setIsFlagged(flag);
  }, [flag, editId]);

  const handleClick = async () => {
    if (!user) return;
    try {
      await updateEdit({
        variables: {
          id: editId,
          edit: {
            flag: !isFlagged,
          },
        },
      });
    } catch (error) {
      console.error("Failed to update flag in database:", error);
    }
  };

  return (
    <button
      type="button"
      className={`gist-circle-control ${isFlagged ? "is-active is-danger" : ""}`}
      onClick={handleClick}
      title="Flag"
      aria-label="Flag"
    >
      {isFlagged ? <FaFlag /> : <FaRegFlag />}
    </button>
  );
};

export default FlagComponent;
